export const DELETE_ROLE = 'Delete role';
export const DELETE_ROLE_LABEL = 'Confirm Delete Role';
export const DELETE_ROLE_CONTENT = 'Are you sure you want to delete this role?';
